import axios from "axios";
import { API_ADMIN_URL } from './config';

const API_URL = API_ADMIN_URL;

// Gửi cookie tự động cho mọi request cross-origin
axios.defaults.withCredentials = true;

class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "/user/login", {
        username,
        password
      })
      .then(response => {
        if (response.data.success) {
          // Chỉ lưu metadata (role, fullname) - token đã nằm trong httpOnly cookie
          localStorage.setItem("user", JSON.stringify({
            role: response.data.role,
            fullname: response.data.fullname
          }));
        }

        return response.data;
      });
  }

  refreshToken() {
    return axios
      .post(API_URL + "/user/refresh")
      .then(response => {
        if (response.data.success) {
          localStorage.setItem("user", JSON.stringify({
            role: response.data.role,
            fullname: response.data.fullname
          }));
        }
        return response.data;
      });
  }

  logout() {
    return axios
      .post(API_URL + "/user/logout")
      .then(() => {
        localStorage.removeItem("user");
        window.location = "/login";
      })
      .catch(() => {
        localStorage.removeItem("user");
        window.location = "/login";
      });
  }

  getCurrentUser() {
    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch {
      return null;
    }
  }
}

export default new AuthService();
